import * as React from "react";
type Props = {
  className?: string,
};
function SvgVegan2({ className }: Props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 23 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="utility-vegan2"
      className={className}
    >
      <path
        d="M19.8242 10.8907C18.3816 9.54448 16.851 8.91984 15.2666 9.0297C14.8838 9.05681 14.5213 9.12622 14.1821 9.22504C15.3807 7.1852 16.3836 5.80079 16.4087 5.76678L14.9741 4.62505C14.8961 4.73169 14.3068 5.54386 13.5082 6.8083C13.3192 6.20021 13.0285 5.65049 12.6365 5.16282C10.99 3.11425 8.16824 3.00486 8.04887 3.00118C7.58857 2.9759 7.16879 3.36015 7.1243 3.85425C6.95032 5.79206 7.37626 7.37824 8.3898 8.57006C9.30864 9.64974 10.5208 10.159 11.4375 10.3989C10.3997 12.3896 9.38793 14.6928 8.8065 16.9684C6.88248 13.364 4.00483 11.4009 3.85154 11.298L2.875 12.8809C2.91685 12.9094 7.0785 15.7683 8.34223 20.7324L9.4399 20.4281L10.109 20.4391C10.1438 18.2094 10.9838 15.664 12.0401 13.3263C13.1333 14.1679 14.2944 14.5595 15.5093 14.5163C18.0623 14.4088 19.8326 12.2963 19.9066 12.2067C20.2272 11.8178 20.1907 11.2327 19.8242 10.8907ZM9.73899 7.32033C9.23772 6.73062 8.95758 5.96074 8.90164 5.02309C9.62138 5.19362 10.6107 5.56684 11.26 6.38038C11.7189 6.95492 11.9542 7.69677 11.9634 8.59397C11.3 8.43218 10.3861 8.08056 9.73899 7.32033ZM15.4243 12.6355C14.6525 12.6691 13.8909 12.3969 13.1479 11.8376C13.6707 11.4317 14.4618 10.9689 15.4031 10.9073C16.2061 10.8517 17.0179 11.1031 17.8209 11.6491C17.2575 12.0927 16.407 12.5983 15.4243 12.6355Z"
        fill="#214E33"
      />
    </svg>
  );
}
export default SvgVegan2;
